import base from './base'

let controller = 'expert'
let action = null

const Expert = {
  async listExperts (query, pageIndex = 1, pageSize = 20) {
    let querys = {
      currentPage: pageIndex || query.pageIdex,
      pageSize: pageSize || query.pageSize,
      sort: query.sort,
      ascending: query.ascending
    }
    Object.assign(querys, query)
    action = 'ListExperts'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: querys
    }
    return base.request(reqModel)
  },

  async addExpert (request) {
    let model = {
      type: request.type,
      name: request.name || null,
      registeredNo: request.registeredNo || null,
      registeredLevel: request.registeredLevel || null,
      contactTel: request.contactTel || null,
      email: request.email || null
    }
    action = 'Create'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: model
    }
    return base.request(reqModel)
  },

  async updateExpert (request) {
    let model = {
      id: request.id || request.tid || null,
      type: request.type,
      name: request.name || null,
      registeredNo: request.registeredNo || null,
      registeredLevel: request.registeredLevel || null,
      contactTel: request.contactTel || null,
      email: request.email || null
    }
    if (!model.id) {
      throw new Error('提交数据不合法!ID为空')
    }
    action = `Update/${model.id}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: model
    }
    return base.request(reqModel)
  },

  async deleteExpert (expertId) {
    if (!expertId) {
      throw new Error('ExpertId')
    }
    action = `Delete/${expertId}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  }
}

export default Expert